import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch { toast.error("Erreur réseau"); }
  };
  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="forgot-password-page">
      <h1 className="font-display text-4xl text-ink-900 mb-2">Mot de passe oublié</h1>
      <p className="text-muted2 text-sm mb-8">Entrez votre email, nous vous enverrons un lien sécurisé (valable 1h).</p>
      {sent ? (
        <div className="glass rounded-2xl p-6 text-center" data-testid="forgot-password-sent">
          <p className="text-success mb-2">✓ C'est envoyé !</p>
          <p className="text-sm text-muted2">Si un compte existe avec cet email, vous recevrez un lien de réinitialisation.</p>
          <Link to="/login" className="inline-block mt-5 text-gold-700 hover:text-gold-700-700-600 text-sm">← Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-4">
          <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="vous@email.com"
            className="w-full bg-white border border-gold-200 rounded-lg px-3 py-3 text-ink-900 placeholder:text-ink-400 focus:outline-none focus:border-gold-400"
            data-testid="forgot-password-email-input" />
          <button type="submit" className="w-full px-5 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400 shadow-gold" data-testid="forgot-password-submit-button">
            Envoyer le lien
          </button>
        </form>
      )}
    </div>
  );
}
